.items {
	display: grid;
	grid-auto-flow: row;
	grid-auto-rows: 1fr;
	padding: var(--size-2);
}

.item {
	--dropdown-item-background-highlight: var(--color-primary);
	--dropdown-item-text: var(--color-text);
	--dropdown-item-text-highlight: var(--blue-100);

	width: 100%;
	min-width: 10rem;
	display: grid;
	grid-template: "icon text" 1fr / 0.75rem 1fr;
	align-items: center;
	justify-items: start;
	align-content: center;
	gap: var(--size-4);
	padding: var(--size-2) var(--size-4);
	border: none;
	background-color: transparent;
	border-radius: var(--radius-md);
	color: var(--dropdown-item-text);
	text-decoration: none;

	&:disabled,
	&:has(input:disabled) {
		opacity: 0.5;
	}

	&:where(button, a, label):not(:disabled, :has(input:disabled)) {
		&:focus-visible,
		&:has(input:focus-visible),
		.items:not(:has(:focus-visible)) &:hover {
			background-color: var(--dropdown-item-background-highlight);
			color: var(--dropdown-item-text-highlight);
			outline: none;
		}
	}

	[data-icons="false"] & {
		grid-template: "text" 1fr / 1fr;
	}

	&[data-kind="negative"] {
		--dropdown-item-background-highlight: var(--red-600);
		--dropdown-item-text: var(--color-error-foreground);
		--dropdown-item-text-highlight: var(--red-100);
	}

	&[data-kind="primary"] {
		--dropdown-item-text: var(--color-primary-foreground);
	}
}

.label {
	grid-area: text;
}

.icon {
	grid-area: icon;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
